'use strict';

export default class SignupChoiceController {
  constructor(BreadcrumbService, LogRocketService) {
    'ngInject';

    /** @type {BreadcrumbService} */
    this._breadcrumbService = BreadcrumbService;
    /** @type {LogRocketService} */
    this._logRocketService = LogRocketService;

    this._isLoading = false;
  }

  /**
   * @return {boolean}
   */
  get isLoading() {
    return this._isLoading;
  }

  goBack() {
    this._breadcrumbService.goBack('root.login');
  }

  goToCreateTeacherAccount() {
    this._breadcrumbService.go('root.signup-teacher');
  }

  goToProInviteStudent() {
    this._breadcrumbService.go('root.signup-student');
  }
}
